import React, { useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Col from 'react-bootstrap/Col';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import IconosGenerales from '../iconos/IconosGenerales';
import ImagenDefault from './../../img/imgDefault.png';

const API_URL = process.env.REACT_APP_API_URL;

// Tarjeta de curso para el sistema NUEVO de áreas (modelo sepe_cursos).
// Mismo look que la tarjeta antigua (EstilosCards) pero consume {id, nombre,
// url, imagen, horas, convocatoria} y enlaza al detalle /areas/:slug/:cursoUrl.
const CardCursoArea = ({ cursos = [], slug }) => {
  useEffect(() => {
    const cards = document.querySelectorAll('.cardddd-area');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = 0;
          entry.target.style.animation = 'aparecer 0.6s ease forwards';
          entry.target.style.animationDelay = `${i * 0.15}s`;
        }
      });
    }, { threshold: 0 });
    cards.forEach((card) => observer.observe(card));
    return () => observer.disconnect();
  }, [cursos]);

  const imagenCurso = (curso) =>
    curso.imagen ? `${API_URL}/api/sepeformacion/public/cursos/imagen/${curso.imagen}` : ImagenDefault;

  return (
    <>
      {cursos.map((curso) => {
        // En /areas/:slug el área es la del contexto (prop `slug`). En la home
        // cada curso trae sus áreas → se usa la primera. Retrocompatible.
        const areaSlug = slug || curso.areas?.[0]?.slug;
        return (
        <Columna lg="3" sm="12" md="4" key={curso.id}>
          <Link to={`/areas/${areaSlug}/${curso.url}`} style={{ textDecoration: 'none' }}>
            <EstilosCards className="cardddd-area">
              <LazyLoad height={200} once>
                <Card.Img
                  variant="top"
                  src={imagenCurso(curso)}
                  alt={curso.nombre}
                  onError={(e) => { e.target.src = ImagenDefault; }}
                />
              </LazyLoad>
              <Card.Body>
                <Link to={`/areas/${areaSlug}/${curso.url}`} title={curso.nombre}>
                  {curso.nombre.toUpperCase()}
                </Link>
              </Card.Body>
              {curso.horas != null && (
                <ListGroup className="list-group-flush">
                  <ListGroup.Item>
                    <IconosGenerales id="reloj" /> {curso.horas}
                  </ListGroup.Item>
                </ListGroup>
              )}
            </EstilosCards>
          </Link>
        </Columna>
        );
      })}
    </>
  );
};

const Columna = styled(Col)`
  margin-top: 5% !important;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EstilosCards = styled(Card)`
  text-align: left;
  width: 16.5rem !important;
  height: 24rem !important;

  p { text-transform: capitalize; }

  a {
    text-decoration: none;
    color: black;
    font-weight: bolder;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    font-size: 1rem;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    transition: 0.5s ease;
    a { color: #ee805d; }
  }

  .card-img-top {
    width: 100%;
    height: 12rem;
    object-fit: cover;
  }
`;

export default CardCursoArea;
